export const LOCAL_TIME_ZONE = Intl.DateTimeFormat().resolvedOptions().timeZone
export const TIME_FMT = 'HH:mm'
export const DATE_FMT = 'YYYY-MM-DD'
export const DATE_TIME_FMT = 'YYYY-MM-DD HH:mm:ss'
export const LOCAL_DATE_FMT = 'DD-MMM-YYYY'
export const LOCAL_DATE_TIME_FMT = 'DD/MMM/YYYY hh:mm a'